import React from "react";

interface AmountInputProps {
  amount: string;
  onAmountChange: (amount: string) => void;
  orderTotal: number;
  onValidationError: (error: string) => void;
}

export const AmountInput: React.FC<AmountInputProps> = ({
  amount,
  onAmountChange,
  orderTotal,
  onValidationError,
}) => {
  const handleAmountChange = (value: string) => {
    onAmountChange(value);

    if (value) {
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        onValidationError("Discount amount must be positive");
      } else if (numValue > orderTotal) {
        onValidationError("Discount amount can not exceed order total");
      }
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="text-[#333333] text-sm leading-[100%] font-medium">
        Amount
      </label>
      <div className="relative flex items-center border border-[#C4C4C4] rounded-[6px] p-[6px] focus-within:border-[#1B4ED7] focus-within:ring-1 focus-within:ring-[#1B4ED7] transition-colors">
        <span className="text-[#666666] font-medium rounded-[6px] mr-3 p-2.5 bg-[#F9F9F9]">
          INR
        </span>
        <input
          type="number"
          value={amount}
          onChange={(e) => handleAmountChange(e.target.value)}
          min="0"
          max={orderTotal}
          step="1"
          placeholder="1,000"
          className="w-full border-0 text-sm leading-[16px] tracking-[-0.001rem] bg-transparent focus:outline-none text-[#333333] font-medium placeholder-gray-400"
        />
      </div>
    </div>
  );
};
